<template>
  <div class="fac-page">

    <!-- PAGE HEADER -->
    <div class="pg-header">
      <div class="pg-breadcrumb">ຂໍ້ມູນໂຮງຮຽນ <i class="fas fa-chevron-right sep"></i> <span>ສິ່ງອຳນວຍຄວາມສະດວກ</span></div>
      <h1 class="pg-title"><i class="fas fa-building"></i> ຈັດການຂໍ້ມູນສິ່ງອຳນວຍຄວາມສະດວກ</h1>
      <p class="pg-sub">ບັນທຶກ ແລະ ກວດສອບຄວາມພ້ອມດ້ານອຸປະກອນ ແລະ ສິ່ງອຳນວຍຄວາມສະດວກຕ່າງໆ</p>
    </div>

    <!-- LOADING -->
    <div v-if="loading" class="loading-box">
      <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
      <p>ກຳລັງໂຫຼດຂໍ້ມູນ...</p>
    </div>

    <form v-else @submit.prevent="handleSubmit">

      <!-- ======================================
           CARD 1: ຂໍ້ມູນລະບຸໂຮງຮຽນ (Fields 1-7)
      ======================================= -->
      <div class="card">
        <div class="card-head">
          <i class="fas fa-id-card icon-head"></i>
          <div>
            <div class="card-title">ຂໍ້ມູນລະບຸໂຮງຮຽນ</div>
            <div class="card-subtitle">ຂໍ້ມູນຫຼັກທີ່ລະບຸຕົວໂຮງຮຽນ (Fields 1–7)</div>
          </div>
        </div>
        <div class="card-body">
          <div class="grid-4">
            <div class="fg">
              <label class="fl req">1. ສົກຮຽນ</label>
              <input class="fi" type="text" v-model="form.academic_year" placeholder="ຕົວຢ່າງ: 2024-2025" maxlength="9">
            </div>
            <div class="fg">
              <label class="fl">2. ລະຫັດໂຮງຮຽນ</label>
              <input class="fi auto" type="text" :value="schoolInfo.school_id || user.school_id || user.school_code" disabled>
            </div>
            <div class="fg">
              <label class="fl">3. ຊື່ແຂວງ</label>
              <input class="fi auto" type="text" :value="schoolInfo.prov_name || user.prov_name || user.province_name" disabled>
            </div>
            <div class="fg">
              <label class="fl">4. ຊື່ເມືອງ</label>
              <input class="fi auto" type="text" :value="schoolInfo.district_name_lao || user.district_name_lao || user.district_name" disabled>
            </div>
          </div>
          <div class="grid-3">
            <div class="fg">
              <label class="fl">5. ຊື່ຕາແສງ</label>
              <input class="fi auto" type="text" :value="schoolInfo.commune_name || ''" disabled>
            </div>
            <div class="fg">
              <label class="fl">6. ຊື່ບ້ານທີ່ໂຮງຮຽນຕັ້ງຢູ່</label>
              <input class="fi auto" type="text" :value="schoolInfo.school_village || ''" disabled>
            </div>
            <div class="fg">
              <label class="fl">7. ຊື່ໂຮງຮຽນ</label>
              <input class="fi auto" type="text" :value="schoolInfo.school_name_lao || user.school_name" disabled>
            </div>
          </div>
        </div>
      </div>

      <!-- ======================================
           CARD 2: ໄຟຟ້າ (Field 8)
      ======================================= -->
      <div class="card">
        <div class="card-head">
          <i class="fas fa-bolt icon-head icon-yellow"></i>
          <div>
            <div class="card-title">ໄຟຟ້າ</div>
            <div class="card-subtitle">Field 8</div>
          </div>
        </div>
        <div class="card-body">

          <div class="qrow">
            <div class="qnum">8</div>
            <div class="qlabel">ໂຮງຮຽນແຫ່ງນີ້ ມີໄຟຟ້າໃຊ້ໃນໂຮງຮຽນບໍ່</div>
            <div class="qctrl">
              <select class="fsel" v-model.number="form.has_electricity"
                      @change="form.electricity_type = null">
                <option value="">-- ເລືອກ --</option>
                <option :value="1">1. ມີ</option>
                <option :value="2">2. ບໍ່ມີ</option>
              </select>
            </div>
          </div>

          <div v-if="form.has_electricity === 1" class="subcard">
            <div class="subcard-tag"><i class="fas fa-level-down-alt"></i> ສະແດງຍ້ອນ Field 8 = ມີ</div>
            <div class="qrow sub">
              <div class="qnum sub-num">8.1</div>
              <div class="qlabel">ແມ່ນໄຟຟ້າປະເພດໃດ</div>
              <div class="qctrl">
                <select class="fsel" v-model.number="form.electricity_type">
                  <option value="">-- ເລືອກ --</option>
                  <option :value="1">1. ໄຟຟ້າເຄືອຂ່າຍ</option>
                  <option :value="2">2. ເຟຟ້າຈັກ</option>
                  <option :value="3">3. ໄຟຟ້າແສງຕາເວັນ</option>
                  <option :value="4">4. ອື່ນໆ</option>
                </select>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- ======================================
           CARD 3: ອຸປະກອນໄອທີ (Fields 9-15)
      ======================================= -->
      <div class="card">
        <div class="card-head">
          <i class="fas fa-laptop-code icon-head icon-blue"></i>
          <div>
            <div class="card-title">ອຸປະກອນໄອທີ ແລະ ເຕັກໂນໂລຊີ</div>
            <div class="card-subtitle">Fields 9–15</div>
          </div>
        </div>
        <div class="card-body no-pad">

          <div v-for="dev in devices" :key="dev.key" class="devblock">
            <div class="qrow devrow">
              <div class="qnum">{{ dev.num }}</div>
              <div class="qlabel">{{ dev.label }}</div>
              <div class="qctrl">
                <select class="fsel" v-model.number="form[dev.key + '_has']"
                        @change="form[dev.key + '_count'] = null; form[dev.key + '_purpose'] = null">
                  <option value="">-- ເລືອກ --</option>
                  <option :value="1">1. ມີ</option>
                  <option :value="2">2. ບໍ່ມີ</option>
                </select>
              </div>
            </div>

            <div v-if="form[dev.key + '_has'] === 1" class="dev-subcard">
              <div class="subcard-tag"><i class="fas fa-level-down-alt"></i> ສະແດງຍ້ອນ Field {{ dev.num }} = ມີ</div>
              <div class="sub-inline-grid">
                <div class="fg">
                  <label class="fl">{{ dev.num }}.1 ຈໍານວນ ({{ dev.unit }})</label>
                  <input class="fi" type="number" v-model.number="form[dev.key + '_count']" min="0" placeholder="0">
                </div>
                <div class="fg">
                  <label class="fl">{{ dev.num }}.2 ຈຸດປະສົງໃນການນໍາໃຊ້</label>
                  <select class="fsel" v-model.number="form[dev.key + '_purpose']">
                    <option value="">-- ເລືອກ --</option>
                    <option v-for="p in PURPOSE_OPTIONS" :key="p.value" :value="p.value">{{ p.value }}. {{ p.label }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- ======================================
           CARD 4: ໂທລະສັບ & ແຟັກ (Fields 16-17)
      ======================================= -->
      <div class="card">
        <div class="card-head">
          <i class="fas fa-phone-alt icon-head icon-green"></i>
          <div>
            <div class="card-title">ໂທລະສັບ ແລະ ແຟັກ</div>
            <div class="card-subtitle">Fields 16–17</div>
          </div>
        </div>
        <div class="card-body">

          <div class="qrow">
            <div class="qnum">16</div>
            <div class="qlabel">ໂຮງຮຽນແຫ່ງນີ້ ມີເບີໂທລະສັບສະເພາະຂອງໂຮງຮຽນບໍ່</div>
            <div class="qctrl">
              <select class="fsel" v-model.number="form.has_phone"
                      @change="form.school_phone = ''; form.contact_phone = ''">
                <option value="">-- ເລືອກ --</option>
                <option :value="1">1. ມີ</option>
                <option :value="2">2. ບໍ່ມີ</option>
              </select>
            </div>
          </div>

          <div v-if="form.has_phone === 1" class="subcard">
            <div class="subcard-tag"><i class="fas fa-level-down-alt"></i> ສະແດງຍ້ອນ Field 16 = ມີ</div>
            <div class="qrow sub">
              <div class="qnum sub-num">16.1</div>
              <div class="qlabel">ເບີໂທລະສັບໂຮງຮຽນ</div>
              <div class="qctrl">
                <input class="fi" type="text" v-model="form.school_phone" placeholder="030 xxx xxx" maxlength="15">
              </div>
            </div>
          </div>

          <div v-if="form.has_phone === 2" class="subcard subcard-orange">
            <div class="subcard-tag subcard-tag-orange"><i class="fas fa-level-down-alt"></i> ສະແດງຍ້ອນ Field 16 = ບໍ່ມີ</div>
            <div class="qrow sub">
              <div class="qnum sub-num-orange">16.2</div>
              <div class="qlabel">ສາມາດຕິດຕໍ່ໄດ້ເບີໃດ</div>
              <div class="qctrl">
                <input class="fi" type="text" v-model="form.contact_phone" placeholder="020 xxxx xxxx" maxlength="15">
              </div>
            </div>
          </div>

          <div class="qrow-divider"></div>

          <div class="qrow">
            <div class="qnum">17</div>
            <div class="qlabel">ໂຮງຮຽນແຫ່ງນີ້ ມີເບີແຟັກສະເພາະຂອງໂຮງຮຽນບໍ່</div>
            <div class="qctrl">
              <select class="fsel" v-model.number="form.has_fax" @change="form.fax_number = ''">
                <option value="">-- ເລືອກ --</option>
                <option :value="1">1. ມີ</option>
                <option :value="2">2. ບໍ່ມີ</option>
              </select>
            </div>
          </div>

          <div v-if="form.has_fax === 1" class="subcard">
            <div class="subcard-tag"><i class="fas fa-level-down-alt"></i> ສະແດງຍ້ອນ Field 17 = ມີ</div>
            <div class="qrow sub">
              <div class="qnum sub-num">17.1</div>
              <div class="qlabel">ເບີແຟັກ</div>
              <div class="qctrl">
                <input class="fi" type="text" v-model="form.fax_number" placeholder="021 xxx xxx" maxlength="15">
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- ======================================
           CARD 5: ບໍລິເວນ ແລະ ອື່ນໆ (Fields 18-22)
      ======================================= -->
      <div class="card">
        <div class="card-head">
          <i class="fas fa-tree icon-head icon-teal"></i>
          <div>
            <div class="card-title">ບໍລິເວນ ແລະ ສິ່ງອຳນວຍຄວາມສະດວກອື່ນໆ</div>
            <div class="card-subtitle">Fields 18–22</div>
          </div>
        </div>
        <div class="card-body">

          <div class="qrow">
            <div class="qnum">18</div>
            <div class="qlabel">ໂຮງຮຽນແຫ່ງນີ້ ມີເດີ່ນຫຼິ້ນກາງແຈ້ງບໍ່</div>
            <div class="qctrl">
              <select class="fsel" v-model.number="form.has_playground">
                <option value="">-- ເລືອກ --</option>
                <option :value="1">1. ມີ</option>
                <option :value="2">2. ບໍ່ມີ</option>
              </select>
            </div>
          </div>

          <div class="qrow">
            <div class="qnum">19</div>
            <div class="qlabel">ໂຮງຮຽນແຫ່ງນີ້ ມີເຄື່ອງຫຼິ້ນກາງແຈ້ງບໍ່</div>
            <div class="qctrl">
              <select class="fsel" v-model.number="form.has_playground_equip"
                      @change="form.playground_equip_types = []">
                <option value="">-- ເລືອກ --</option>
                <option :value="1">1. ມີ</option>
                <option :value="2">2. ບໍ່ມີ</option>
              </select>
            </div>
          </div>

          <div v-if="form.has_playground_equip === 1" class="subcard">
            <div class="subcard-tag"><i class="fas fa-level-down-alt"></i> ສະແດງຍ້ອນ Field 19 = ມີ &nbsp;·&nbsp; ເລືອກໄດ້ຫຼາຍຄໍາຕອບ</div>
            <div class="sub-label-row">
              <div class="qnum sub-num" style="flex-shrink:0">19.1</div>
              <div class="qlabel">ມີເຄື່ອງຫຼິ້ນປະເພດໃດແດ່</div>
            </div>
            <div class="check-group">
              <label v-for="eq in PLAYGROUND_EQUIP" :key="eq.value" class="check-chip">
                <input type="checkbox" :value="eq.value" v-model="form.playground_equip_types">
                <span class="check-box"></span>
                <span class="check-txt">{{ eq.value }}. {{ eq.label }}</span>
              </label>
            </div>
          </div>

          <div class="qrow">
            <div class="qnum">20</div>
            <div class="qlabel">ໂຮງຮຽນແຫ່ງນີ້ ມີຮົ້ວໂຮງຮຽນບໍ່</div>
            <div class="qctrl">
              <select class="fsel" v-model.number="form.has_fence">
                <option value="">-- ເລືອກ --</option>
                <option :value="1">1. ມີ</option>
                <option :value="2">2. ບໍ່ມີ</option>
              </select>
            </div>
          </div>

          <div class="qrow">
            <div class="qnum">21</div>
            <div class="qlabel">ໂຮງຮຽນແຫ່ງນີ້ ມີຫໍຂ່າວໂຮງຮຽນບໍ່</div>
            <div class="qctrl">
              <select class="fsel" v-model.number="form.has_news_board">
                <option value="">-- ເລືອກ --</option>
                <option :value="1">1. ມີ</option>
                <option :value="2">2. ບໍ່ມີ</option>
              </select>
            </div>
          </div>

          <div class="qrow">
            <div class="qnum">22</div>
            <div class="qlabel">ໂຮງຮຽນແຫ່ງນີ້ ມີຫຼັກທຸງ / ທຸງຊາດບໍ່</div>
            <div class="qctrl">
              <select class="fsel" v-model.number="form.has_flagpole">
                <option value="">-- ເລືອກ --</option>
                <option :value="1">1. ມີ</option>
                <option :value="2">2. ບໍ່ມີ</option>
              </select>
            </div>
          </div>

        </div>
      </div>

      <!-- SAVE BUTTON -->
      <div class="save-bar">
        <button type="submit" class="btn-save" :disabled="submitting">
          <i class="fas" :class="submitting ? 'fa-spinner fa-spin' : 'fa-save'"></i>
          {{ submitting ? 'ກຳລັງບັນທຶກ...' : 'ບັນທຶກຂໍ້ມູນສິ່ງອຳນວຍຄວາມສະດວກ' }}
        </button>
      </div>

    </form>

    <!-- RESULT MODAL -->
    <transition name="modal">
      <div v-if="resultModal.show" class="modal-overlay" @mousedown.self="resultModal.show = false">
        <div class="custom-modal-card result-modal">
          <div class="modal-icon" :class="resultModal.type">
            <i class="fas" :class="resultModal.type === 'success' ? 'fa-check-circle' : 'fa-times-circle'"></i>
          </div>
          <div class="modal-content-area">
            <h2>{{ resultModal.title }}</h2>
            <p>{{ resultModal.message }}</p>
          </div>
          <div class="modal-footer-actions">
            <button class="btn-modal-primary" :class="resultModal.type" @click="resultModal.show = false">ເຂົ້າໃຈແລ້ວ</button>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import api from '@/utils/api';

const PURPOSE_OPTIONS = [
  { value: 1, label: 'ບໍລິຫານ' },
  { value: 2, label: 'ການຮຽນ-ການສອນ' },
  { value: 3, label: 'ບໍລິຫານ ແລະ ການຮຽນ-ການສອນ' }
];

const PLAYGROUND_EQUIP = [
  { value: 1, label: 'ໂອນຊາ (Seesaw)' },
  { value: 2, label: 'ໝາກຕະລູດ (Slide)' },
  { value: 3, label: 'ໄມ້ເດື່ອງດັບ (Swing)' },
  { value: 4, label: 'ອື່ນ (Other)' }
];

const DEVICES = [
  { key: 'desktop',   num: 9,  label: 'ໂຮງຮຽນແຫ່ງນີ້ ມີຄອມພິວເຕີ້ຕັ້ງໂຕະບໍ່',     unit: 'ໜ່ວຍ' },
  { key: 'laptop',    num: 10, label: 'ໂຮງຮຽນແຫ່ງນີ້ ມີຄອມພິວເຕີ້ມືຖືບໍ່',         unit: 'ໜ່ວຍ' },
  { key: 'printer',   num: 11, label: 'ໂຮງຮຽນແຫ່ງນີ້ ມີເຄື່ອງພິມເອກະສານບໍ່',       unit: 'ໜ່ວຍ' },
  { key: 'tablet',    num: 12, label: 'ໂຮງຮຽນແຫ່ງນີ້ ມີແທັບເລັດບໍ່',               unit: 'ໜ່ວຍ' },
  { key: 'tv',        num: 13, label: 'ໂຮງຮຽນແຫ່ງນີ້ ມີໂທລະພາບບໍ່',                unit: 'ໜ່ວຍ' },
  { key: 'projector', num: 14, label: 'ໂຮງຮຽນແຫ່ງນີ້ ມີໂປຣເຈັກເຕີ້ບໍ່',            unit: 'ໜ່ວຍ' },
  { key: 'internet',  num: 15, label: 'ໂຮງຮຽນແຫ່ງນີ້ ມີອິນເຕີເນັດບໍ່',             unit: 'ຊຸດ'  }
];

function buildDeviceFields() {
  const f = {};
  DEVICES.forEach(d => {
    f[d.key + '_has']     = null;
    f[d.key + '_count']   = null;
    f[d.key + '_purpose'] = null;
  });
  return f;
}

export default {
  name: 'SchoolFacilitiesPage',
  data() {
    return {
      loading: false,
      submitting: false,
      isNew: true,
      user: {},
      schoolInfo: { school_id: '', prov_name: '', district_name_lao: '', school_name_lao: '', commune_name: '', school_village: '' },
      PURPOSE_OPTIONS,
      PLAYGROUND_EQUIP,
      devices: DEVICES,
      form: {
        school_id: '',
        academic_year: '',
        commune_name: '',
        school_village: '',
        has_electricity: null,
        electricity_type: null,
        ...buildDeviceFields(),
        has_phone: null,
        school_phone: '',
        contact_phone: '',
        has_fax: null,
        fax_number: '',
        has_playground: null,
        has_playground_equip: null,
        playground_equip_types: [],
        has_fence: null,
        has_news_board: null,
        has_flagpole: null
      },
      resultModal: { show: false, type: 'success', title: '', message: '' }
    };
  },
  async mounted() {
    this.user = JSON.parse(localStorage.getItem('user-info') || '{}');
    await Promise.all([this.fetchSchoolInfo(), this.fetchData()]);
  },
  methods: {
    async fetchSchoolInfo() {
      if (!this.user.school_id) return;
      try {
        const res = await api.get(`/getAll/schools/school_id/${this.user.school_id}`);
        if (res.data.code === 1 && res.data.rows.length > 0) {
          const s = res.data.rows[0];
          this.schoolInfo = {
            school_id: s.school_id || this.user.school_id,
            prov_name: s.prov_name || '',
            district_name_lao: s.district_name_lao || '',
            school_name_lao: s.school_name_lao || '',
            commune_name: s.commune_name || '',
            school_village: s.school_village || '',
          };
        }
      } catch (e) { console.error(e); }
    },
    async fetchData() {
      if (!this.user.school_id) return;
      this.loading = true;
      try {
        const res = await api.get(`/getAll/school_facilities/school_id/${this.user.school_id}`);
        if (res.data.code === 1 && res.data.rows.length > 0) {
          const d = res.data.rows[0];
          if (!Array.isArray(d.playground_equip_types)) d.playground_equip_types = [];
          this.form = { ...this.form, ...d };
          this.isNew = false;
        } else {
          this.form.school_id = this.user.school_id;
          this.isNew = true;
        }
      } catch (e) { console.error(e); }
      finally { this.loading = false; }
    },
    async handleSubmit() {
      this.submitting = true;
      try {
        let res;
        if (this.isNew) {
          res = await api.post('/insertOne', { table: 'school_facilities', items: this.form });
        } else {
          res = await api.put(`/update/school_facilities/${this.form._id}`, { items: this.form });
        }
        if (res.data.code === 1) {
          this.resultModal = { show: true, type: 'success', title: 'ສຳເລັດ!', message: 'ບັນທຶກຂໍ້ມູນສິ່ງອຳນວຍຄວາມສະດວກຮຽບຮ້ອຍແລ້ວ' };
          await this.fetchData();
        }
      } catch (e) {
        this.resultModal = { show: true, type: 'error', title: 'ເກີດຂໍ້ຜິດພາດ', message: 'ບໍ່ສາມາດບັນທຶກຂໍ້ມູນໄດ້' };
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped>
/* ============================================================
   BASE
============================================================ */
.fac-page {
  max-width: 960px;
  margin: 0 auto;
  padding: 0 0 40px;
  font-family: 'Phetsarath OT', 'Noto Sans Lao', sans-serif;
  animation: fadeUp 0.35s ease;
}

/* ============================================================
   PAGE HEADER
============================================================ */
.pg-header      { margin-bottom: 24px; }
.pg-breadcrumb  { font-size: 13px; color: #94a3b8; margin-bottom: 6px; }
.pg-breadcrumb .sep { font-size: 10px; margin: 0 5px; }
.pg-breadcrumb span { color: #334155; font-weight: 600; }
.pg-title { font-size: 22px; color: #0f172a; margin: 0 0 4px; display: flex; align-items: center; gap: 10px; }
.pg-title i { color: var(--lao, #003f8a); }
.pg-sub { font-size: 13px; color: #64748b; margin: 0; }

/* ============================================================
   CARD
============================================================ */
.card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.07), 0 4px 16px rgba(0,0,0,0.04);
  margin-bottom: 20px;
  overflow: hidden;
}
.card-head {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 15px 24px;
  border-bottom: 1px solid #f1f5f9;
  background: #fafbfc;
}
.icon-head   { font-size: 20px; width: 22px; text-align: center; color: var(--lao, #003f8a); }
.icon-yellow { color: #f59e0b; }
.icon-blue   { color: #3b82f6; }
.icon-green  { color: #10b981; }
.icon-teal   { color: #14b8a6; }
.card-title    { font-size: 15px; font-weight: 700; color: #1e293b; }
.card-subtitle { font-size: 12px; color: #94a3b8; margin-top: 2px; }
.card-body     { padding: 20px 24px; }
.card-body.no-pad { padding: 0; }

/* ============================================================
   IDENTITY GRIDS
============================================================ */
.grid-4 { display: grid; grid-template-columns: repeat(4, 1fr); gap: 14px; margin-bottom: 14px; }
.grid-3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px; }

.fg { position: relative; }
.fl { display: block; font-size: 12px; font-weight: 600; color: #64748b; margin-bottom: 5px; }
.fl.req::after { content: ' *'; color: #ef4444; }

.fi {
  width: 100%; padding: 9px 12px;
  border: 1.5px solid #e2e8f0; border-radius: 9px;
  font-size: 14px; font-family: inherit; box-sizing: border-box;
  transition: border-color 0.18s, box-shadow 0.18s;
}
.fi:focus  { outline: none; border-color: var(--lao, #003f8a); box-shadow: 0 0 0 3px rgba(0,63,138,0.1); }
.fi.auto   { background: #f8fafc; color: #64748b; cursor: not-allowed; }

/* ============================================================
   QUESTION ROW
   Layout: [number] [label flex-1] [control 260px]
   All 3 children in one flex line — no wrapping issues
============================================================ */
.qrow {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 13px 0;
  border-bottom: 1px solid #f1f5f9;
}
.qrow:last-child { border-bottom: none; }
.qrow.sub        { padding: 8px 0 0; border-bottom: none; }

/* Number badge */
.qnum {
  flex-shrink: 0;
  min-width: 40px;
  height: 36px;
  background: var(--lao, #003f8a);
  color: #fff;
  border-radius: 9px;
  display: flex; align-items: center; justify-content: center;
  font-size: 12px; font-weight: 700; letter-spacing: 0.3px;
  padding: 0 6px;
}
.sub-num        { background: #dbeafe; color: #1d4ed8; font-size: 11px; }
.sub-num-orange { background: #fed7aa; color: #c2410c; font-size: 11px;
                  flex-shrink: 0; min-width: 40px; height: 36px;
                  border-radius: 9px; display: flex; align-items: center;
                  justify-content: center; font-weight: 700; padding: 0 6px; }

/* Label */
.qlabel { flex: 1; font-size: 14px; color: #1e293b; font-weight: 500; line-height: 1.5; }

/* Control (dropdown / input) */
.qctrl { flex-shrink: 0; width: 260px; }

.fsel {
  width: 100%; padding: 9px 12px;
  border: 1.5px solid #e2e8f0; border-radius: 9px;
  font-size: 14px; font-family: inherit; background: #fff; cursor: pointer;
  transition: border-color 0.18s, box-shadow 0.18s;
}
.fsel:focus { outline: none; border-color: var(--lao, #003f8a); box-shadow: 0 0 0 3px rgba(0,63,138,0.1); }

/* ============================================================
   SUBCARD  (conditional block)
============================================================ */
.subcard {
  margin: 10px 0 10px 56px;
  background: #f0f9ff;
  border: 1.5px solid #bae6fd;
  border-radius: 12px;
  padding: 12px 16px 14px;
}
.subcard-orange {
  background: #fff7ed;
  border-color: #fed7aa;
}

.subcard-tag {
  font-size: 11px; font-weight: 700; color: #0284c7;
  display: flex; align-items: center; gap: 5px;
  margin-bottom: 8px;
}
.subcard-tag-orange { color: #ea580c; }

/* Sub-label + num row (for 19.1) */
.sub-label-row {
  display: flex; align-items: center; gap: 10px;
  margin-bottom: 10px;
}

/* ============================================================
   DEVICE BLOCK
============================================================ */
.devblock { border-bottom: 1px solid #f1f5f9; padding: 0 24px; }
.devblock:last-child { border-bottom: none; }
.devrow   { border-bottom: none; }

.dev-subcard {
  margin: 0 0 14px 56px;
  background: #f0f9ff;
  border: 1.5px solid #bae6fd;
  border-radius: 12px;
  padding: 12px 16px 14px;
}

.sub-inline-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

/* ============================================================
   DIVIDER
============================================================ */
.qrow-divider { height: 1px; background: #e2e8f0; margin: 6px 0; }

/* ============================================================
   PLAYGROUND EQUIPMENT CHECKBOXES
============================================================ */
.check-group { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 6px; }

.check-chip {
  display: flex; align-items: center; gap: 8px;
  padding: 9px 14px;
  border: 1.5px solid #bae6fd; border-radius: 9px;
  cursor: pointer; transition: 0.15s; background: #fff;
  user-select: none;
}
.check-chip:hover { background: #e0f2fe; border-color: #38bdf8; }
.check-chip input[type='checkbox'] { display: none; }
.check-chip input:checked ~ .check-box { background: var(--lao, #003f8a); border-color: var(--lao, #003f8a); }
.check-chip input:checked ~ .check-box::after { display: block; }
.check-chip input:checked ~ .check-txt { color: var(--lao, #003f8a); font-weight: 700; }

.check-box {
  width: 18px; height: 18px;
  border: 2px solid #94a3b8; border-radius: 5px;
  flex-shrink: 0; position: relative; transition: 0.15s;
}
.check-box::after {
  content: ''; display: none;
  position: absolute; left: 3px; top: 0px;
  width: 6px; height: 10px;
  border: 2.5px solid #fff; border-top: none; border-left: none;
  transform: rotate(45deg);
}
.check-txt { font-size: 14px; color: #334155; transition: 0.15s; white-space: nowrap; }

/* ============================================================
   SAVE BAR
============================================================ */
.save-bar { padding: 4px 0; }
.btn-save {
  width: 100%; padding: 16px; border: none; border-radius: 13px;
  background: var(--lao, #003f8a); color: #fff;
  font-size: 16px; font-weight: 700; font-family: inherit;
  cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 10px;
  transition: transform 0.2s, box-shadow 0.2s, background 0.2s;
}
.btn-save:hover:not(:disabled) {
  background: #002d62;
  transform: translateY(-2px);
  box-shadow: 0 8px 22px rgba(0,63,138,0.28);
}
.btn-save:disabled { opacity: 0.65; cursor: not-allowed; }

/* ============================================================
   RESULT MODAL
============================================================ */
.modal-overlay {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0,0,0,0.4); backdrop-filter: blur(4px);
  display: flex; justify-content: center; align-items: center; z-index: 9999;
}
.custom-modal-card {
  background: white; width: 100%; max-width: 450px;
  border-radius: 16px; box-shadow: 0 20px 25px -5px rgba(0,0,0,0.15);
  overflow: hidden; animation: modalPop 0.3s ease;
}
.result-modal { text-align: center; padding: 40px 30px; }
.modal-icon { font-size: 60px; margin-bottom: 20px; }
.modal-icon.success { color: #10b981; }
.modal-icon.error   { color: #ef4444; }
.modal-content-area h2 { margin: 0 0 8px; color: #1e293b; }
.modal-content-area p  { color: #64748b; margin: 0; }
.modal-footer-actions { margin-top: 28px; }
.btn-modal-primary {
  padding: 12px 40px; border: none; border-radius: 10px;
  font-size: 15px; font-weight: 700; font-family: inherit;
  cursor: pointer; background: var(--lao, #003f8a); color: #fff;
}
.btn-modal-primary.error { background: #ef4444; }

/* ============================================================
   LOADING
============================================================ */
.loading-box {
  display: flex; flex-direction: column; align-items: center;
  padding: 80px 0; gap: 14px; color: #64748b;
}
.text-primary { color: var(--lao, #003f8a); }

/* ============================================================
   ANIMATIONS
============================================================ */
@keyframes fadeUp   { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
@keyframes modalPop { from { opacity: 0; transform: scale(0.9); } to { opacity: 1; transform: scale(1); } }
.modal-enter-active, .modal-leave-active { transition: opacity 0.2s; }
.modal-enter, .modal-leave-to { opacity: 0; }

/* ============================================================
   RESPONSIVE
============================================================ */
@media (max-width: 768px) {
  .grid-4 { grid-template-columns: 1fr 1fr; }
  .grid-3 { grid-template-columns: 1fr 1fr; }
  .qctrl  { width: 150px; }
  .sub-inline-grid { grid-template-columns: 1fr; }
  .subcard, .dev-subcard { margin-left: 0; }
}
@media (max-width: 520px) {
  .grid-4, .grid-3 { grid-template-columns: 1fr; }
  .qrow   { flex-wrap: wrap; }
  .qctrl  { width: 100%; }
  .check-txt { white-space: normal; }
}
</style>
